module.exports = __webpack_public_path__ + "img/dashboard-icon1.d98837ce.svg";